import { DataGrid, type DataGridProps } from '@shared/components';

import { columns } from './columns';

export type MonthlyExamEventDataGridProps = Pick<DataGridProps, 'rows' | 'onRowClick' | 'loading'>;

export default function MonthlyExamEventDataGrid(props: Readonly<MonthlyExamEventDataGridProps>) {
  const { rows, loading: isLoading, onRowClick } = props;

  return (
    <DataGrid
      rows={rows}
      columns={columns}
      loading={isLoading}
      onRowClick={onRowClick}
      disableColumnMenu
      hideFooter
      rowHeight={48}
      sx={(theme) => ({
        border: `1px solid ${theme.palette.grey[300]}`,
        backgroundColor: theme.palette.background.paper,
        minHeight: '100%',
        '.MuiDataGrid-cell': {
          p: theme.spacing(3),
        },
        '.MuiDataGrid-columnHeaders': {
          backgroundColor: theme.palette.grey[100],
          borderBottom: `1px solid ${theme.palette.grey[300]}`,
        },
        '.MuiDataGrid-row > .MuiDataGrid-withBorderColor': {
          borderBottom: `1px solid ${theme.palette.grey[300]}`,
        },
      })}
    />
  );
}
